import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12C1 5.92487 5.92487 1 12 1C18.0752 1 23 5.92487 23 12C23 18.0752 18.0752 23 12 23C5.92487 23 1 18.0752 1 12ZM9.4729 8.38757C9.17319 8.08787 8.68727 8.08787 8.38757 8.38757C8.08787 8.68727 8.08787 9.17319 8.38757 9.4729L10.9146 12L8.38757 14.5271C8.08787 14.8268 8.08787 15.3127 8.38757 15.6124C8.68727 15.9121 9.17319 15.9121 9.4729 15.6124L12 13.0854L14.5271 15.6124C14.8268 15.9121 15.3127 15.9121 15.6124 15.6124C15.9121 15.3127 15.9121 14.8268 15.6124 14.5271L13.0854 12L15.6124 9.4729C15.9121 9.17319 15.9121 8.68727 15.6124 8.38757C15.3127 8.08787 14.8268 8.08787 14.5271 8.38757L12 10.9146L9.4729 8.38757Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
